<template>
  <v-text-field
    v-model="valor"
    :label="label"
    hide-details
    ref="currencyField"
    v-currency="{
      precision: precision ? precision : 0,
      distractionFree: false,
    }"
    @blur="parseValue"
  >
    <template v-slot:append>
      <div v-if="moeda" style="line-height: 22px;">
        {{ moeda }}
      </div>
    </template>
  </v-text-field>
</template>

<script>
import { setValue, parse } from "vue-currency-input";
// import { mapState } from "vuex";

export default {
  name: "CurrencyField",

  props: {
    valor_sync: {
      type: [Number, String],
    },
    moeda: {
      type: String,
    },
    precision: {
      type: [Number, String],
    },
    label: {
      type: String,
      default: "Valor",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      valor: null,
    };
  },

  computed: {
    // ...mapState("Moedas", {
    //   moedas: (state) => state.moedas,
    // }),
  },

  watch: {
    valor_sync() {
      if (this.valor_sync) {
        setValue(this.$refs.currencyField, this.valor_sync);
      }
    },
  },

  methods: {
    parseValue() {
      this.$emit("update:valor_sync", parse(this.valor));
    },
  },

  mounted() {
    if (this.valor_sync) {
      setValue(this.$refs.currencyField, this.valor_sync);
    }
  },
};
</script>

<style lang="scss"></style>
